

<template>
    <v-container fluid class="monospace">
        <!-- Row 1: Flight Segment Presets -->
        <v-row>
        </v-row>

        <!-- Row 2: Flight Segments and Options -->
        <v-row>
            <v-col cols="6" sm="6">
                <v-form>
                    <v-row v-for="(segment, index) in jrmask.FlightSegment" :key="index" class="mb-2">
                        <v-col cols="2">
                            <v-text-field
                                v-model="segment.OriginLocation"
                                label="Origin"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="segment.ConnectionLocation"
                                label="Connection"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="segment.DestinationLocation"
                                label="Destination"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>  
                        <v-col cols="2">
                            <v-text-field
                                v-model="segment.DepartureDateTime"
                                label="Date"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="segment.Routing"
                                label="Routing"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-btn icon @click="jrmask.FlightSegment.splice(index, 1)">
                                <v-icon color="red">mdi-minus</v-icon>
                            </v-btn>
                            <v-btn icon @click="jrmask.FlightSegment.splice(index + 1, 0, { OriginLocation: '', DestinationLocation: '', DepartureDateTime: '' })">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>  
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="jrmask.options.cabin"
                                label="CABIN (P: Premium First, F: First, J: Premium Business, C: Business, S: Premium Economy, Y: Coach)"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="jrmask.options.excluded_countries"
                                label="EXCLUDED COUNTRIES (/XL-)"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="jrmask.options.num_connections"
                                label="# OF CONNECTIONS (/K-)"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="jrmask.options.pax"
                                label="PAX (/P-)"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="jrmask.options.excluded_carriers"
                                label="EXCLUDED CARRIERS (/X-)"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="jrmask.options.carriers"
                                label="PREFERRED CARRIERS (/IA-)"
                                dense
                                hide-details
                                @keyup.enter="getJrCommands"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-checkbox
                                v-model="jrmask.options.exact_day"
                                label="Exact Day"
                                dense
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-checkbox
                                v-model="jrmask.options.long_connection"
                                label="Long Connection"
                                dense
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-checkbox
                                v-model="jrmask.options.search_available"
                                label="Search only available"
                                dense
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
            <v-col cols="5" sm="5">
                <v-card flat>
                    <v-card-title>
                            <v-text-field
                                v-model="jr_params_search"
                                label="Search entries history"
                                dense
                                hide-details
                            />
                    </v-card-title>
                    <v-list dense  style="max-height: 400px; overflow-y: auto;">
                        <v-list-item
                            v-for="(jp, index) in getJrParams(jr_params_search)"
                            :key="index"
                            @click="setJrmask(jp)"
                        >
                            <v-list-item-content>
                                    <v-list-item-title>
                                        {{ jp.FlightSegment.map(seg => seg.OriginLocation + (seg.ConnectionLocation ? '-' + seg.ConnectionLocation : '') + '-' + seg.DestinationLocation + (seg.DepartureDateTime ? ' ' + seg.DepartureDateTime : '')).join(', ') }} | PAX: {{ jp.options.pax }} | CABIN: {{ jp.options.cabin }} | EXC_COUNTRIES: {{ jp.options.excluded_countries }} | EXC_CARRIERS: {{ jp.options.excluded_carriers }} | PREF_CARRIERS: {{ jp.options.carriers }} | EXACT_DAY: {{ jp.options.exact_day !== false }} | LONG_CONN: {{ jp.options.long_connection }} | AVAIL_ONLY: {{ jp.options.search_available }} | #CONN: {{ jp.options.num_connections }}
                                    </v-list-item-title>
                            </v-list-item-content>  </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
            <v-col cols="1" sm="1">
                <v-card flat>
                    <v-card-title>
                        Flight Segment Presets
                    </v-card-title>
                    <v-list dense>
                        <v-list-item link @click.prevent="setFlightSegment('preset0')">
                            <v-list-item-title>MEX-PEK-MEX</v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click.prevent="setFlightSegment('preset1')">
                            <v-list-item-title>MEX-NRT-HKG</v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click.prevent="setFlightSegment('preset2')">
                            <v-list-item-title>HKG-NRT-MEX</v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click.prevent="setFlightSegment('preset3')">
                            <v-list-item-title>MEX-NRT-HKG-NRT</v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click.prevent="setFlightSegment('preset4')">
                            <v-list-item-title>MEX-NRT-HKG-NRT-MEX</v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click.prevent="setFlightSegment('preset5')">
                            <v-list-item-title>MEX-NRT-CAN/HKG-NRT-MEX</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>

        <!-- Row 3: Itinerary Options and Selected Itineraries -->
        <v-row>
            <v-col cols="4" sm="4">
                <!-- Search Results Table (with headers) -->
                <v-data-table
                    :headers="[
                        { title: 'Index', value: 'index' },
                        { title: 'Format', value: 'command' },
                        { title: 'Lowest Fare', value: 'lowest_fare' }
                    ]"
                    :items="result"
                    item-key="command"
                    class="elevation-1"
                >

                    <template v-slot:item="{ item, index }">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td :class="{ 'color-green': item.specific_route_matched }">{{ item.command }}</td>
                            <td>
                                <v-btn small @click="selectSearch(item.parsed_result, index, item.command)">
                                    {{ item.lowest_total !== null ? item.lowest_total.toFixed(0) : "" }}
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>  
            </v-col>

            <v-col cols="4" sm="4">
                <v-select
                    v-model="quoteLanguage"
                    :items="languageOptions"
                    label="Quote Language"
                    density="compact"
                    hide-details
                    class="mb-3"
                />
                <v-card
                    v-for="(o, index) in selected_search"
                    :key="index"
                    class="mb-2"
                    outlined
                    :color="selected_search.command.substring(0, 9).includes('¥A') ? 'red' : 'grey lighten-4'" >
                    <v-card-title>
                        OPTION {{ index + 1 }} VALIDATING CARRIER: {{ o.validating_carrier }}
                    </v-card-title>
                    <v-card-text :class="{ 'color-green': o.specific_route_matched }">

                        <span
                            v-for="(f, i) in o.flights"
                            :key="i"
                        >
                            {{ i + 1 }} <span class="flight-identifier">{{ formatFlightIdentifier(f.airline, f.number) }}</span>{{ f.booking_class }} {{ f.day + f.month }} {{ f.origin + f.destination }} {{ f.departureTime }} {{ f.arrivalTime }} {{ f.stopText }}<br/>  </span>
                        <br/>
                        <table v-if="!o.has_brand_pricing" class="jr-fare-table jr-fare-table--plain">
                            <thead>
                                <tr>
                                    <th class="fare-label-cell"></th>
                                    <th v-for="serviceCharge in serviceChargeOptions" :key="`plain-head-${serviceCharge}`" class="fare-charge-cell">
                                        +{{ serviceCharge }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pp, i) in o.pax_prices" :key="i">
                                    <td class="fare-label-cell">{{ pp.numberOfPax }} {{ pp.passengerType }}</td>
                                    <td v-for="serviceCharge in serviceChargeOptions" :key="`plain-${i}-${serviceCharge}`" class="fare-charge-cell">
                                        <a href class="fare-link" @click.prevent="selectItineraryOption(o, serviceCharge, jrmask.options.cabin)">
                                            {{ formatFareAmount(pp["unitPrice" + serviceCharge]) }}
                                        </a>
                                    </td>
                                </tr>
                                <tr class="fare-total-row">
                                    <td class="fare-label-cell">TOTAL</td>
                                    <td v-for="serviceCharge in serviceChargeOptions" :key="`plain-total-${serviceCharge}`" class="fare-charge-cell">
                                        <a href class="fare-link fare-link--total" @click.prevent="selectItineraryOption(o, serviceCharge, jrmask.options.cabin)">
                                            {{ formatFareAmount(o["total" + serviceCharge]) }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="o.has_brand_pricing" class="brand-block">
                            <div v-for="brand in o.brands" :key="brand.brandId" class="brand-line">
                                <div class="brand-title">
                                    {{ brand.brandId }} {{ brand.displayName || brand.descriptor }}
                                    <span v-if="brand.semanticTags && brand.semanticTags.length" class="brand-tags">
                                        [{{ brand.semanticTags.join(', ') }}]
                                    </span>
                                </div>
                                <div class="brand-details">
                                    <table v-if="getBrandPricingRows(brand).length" class="jr-fare-table brand-table">
                                        <thead>
                                            <tr>
                                                <th class="fare-label-cell"></th>
                                                <th v-for="serviceCharge in serviceChargeOptions" :key="`${brand.brandId}-head-${serviceCharge}`" class="fare-charge-cell">
                                                    +{{ serviceCharge }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row in getBrandPricingRows(brand)" :key="`${brand.brandId}-${row.passengerType}-${row.passengerCount}`">
                                                <td class="fare-label-cell">{{ row.passengerCount }} {{ row.passengerType }}</td>
                                                <td v-for="serviceCharge in serviceChargeOptions" :key="`${brand.brandId}-${row.passengerType}-${serviceCharge}`" class="fare-charge-cell">
                                                    <a href class="fare-link" @click.prevent="selectItineraryOption(o, serviceCharge, jrmask.options.cabin, brand)">
                                                        {{ formatFareAmount(getBrandRowFare(row, serviceCharge)) }}
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr class="fare-total-row">
                                                <td class="fare-label-cell">TOTAL</td>
                                                <td v-for="serviceCharge in serviceChargeOptions" :key="`${brand.brandId}-total-${serviceCharge}`" class="fare-charge-cell">
                                                    <a href class="fare-link fare-link--total" @click.prevent="selectItineraryOption(o, serviceCharge, jrmask.options.cabin, brand)">
                                                        {{ formatFareAmount(getBrandTotalFare(brand, serviceCharge)) }}
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="getPrimaryBrandRule(brand)" class="brand-rules-panel">
                                        <div class="brand-panel-title">Change / Refund</div>
                                        <div class="brand-rules">{{ formatRawPassengerRule(getPrimaryBrandRule(brand)) }}</div>
                                        <v-btn
                                            v-if="getAdditionalBrandRules(brand).length"
                                            size="x-small"
                                            variant="flat"
                                            class="brand-rules-more"
                                            @click="openBrandRulesDialog(brand)"
                                        >
                                            More Rules
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="o.notes && o.notes.length && !o.has_brand_pricing" class="brand-block">
                            <div v-for="note in o.notes" :key="note" class="brand-line">
                                {{ note }}
                            </div>
                        </div>
                        <div class="option-links">
                            <a href @click.prevent="gdsCommand('amadeus', o, jrmask.options.cabin)">AMADEUS</a> /
                            <a href @click.prevent="gdsCommand('sabre', o, jrmask.options.cabin)">SABRE</a>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="4" sm="4">
                在行程旁边的空白处点击一下即可复制完整行程<br/>
                CLICK ON THE BLANK SPACE ON THE RIGHT TO COPY THE ITINERARY<br/>
                <v-card
                    v-for="(selected_itinerary, index) in sortedItineraries"
                    :key="index"
                    class="mb-2"
                    outlined
                    :class="{ stickydiv: index === 0 }"
                >
                                    <v-card-title style="font-size: 12px;">
                                        <span v-if="index === 0" class="fa fa-spinner fa-spin" style="color:red"></span>
                                        {{ selected_itinerary.etc.lang }} / {{ selected_itinerary.etc.serviceCharge }}
                                        <span v-if="selected_itinerary.etc.selectedBrand">
                                            / {{ selected_itinerary.etc.selectedBrand.brandId }}
                                        </span>
                                        ({{ new Date(selected_itinerary.etc.created_date).toLocaleString() }})
                                        <span style="float: right;">
                                            FLIGHT: 
                                            <a href @click.prevent="selected_itinerary.etc.if_show_flight_number = true">VIEW</a>/<a href @click.prevent="selected_itinerary.etc.if_show_flight_number = false">HIDE</a> &nbsp; &nbsp;
                                            <a href @click.prevent="copyDivText(selected_itinerary.etc.amadeus_command)">AMADEUS</a>/ 
                                            <a href @click.prevent="copyDivText(selected_itinerary.etc.sabre_command)">SABRE</a>/
                                            <a href @click.prevent="setJrmask(selected_itinerary.etc.jrmask)">JR</a>
                                        </span>
                                    </v-card-title>
                                    <v-card-text :class="{ 'color-red': index === 0 }" @click="itineraryText(selected_itinerary)">
                                        <pre>{{ itineraryText(selected_itinerary) }}</pre>
                                    </v-card-text>
                                </v-card>  </v-col>  
        </v-row>
        <v-dialog v-model="ruleDialog.open" max-width="640">
                <v-card>
                    <v-card-title>{{ ruleDialog.title }}</v-card-title>
                    <v-card-text>
                        <div v-for="rule in ruleDialog.passengerRules" :key="`${ruleDialog.title}-${rule.passengerType}-${rule.text}`" class="brand-rule-dialog-line">
                        {{ formatRawPassengerRule(rule) }}
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="ruleDialog.open = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios";
import iatacodesData from "@/data/iatacodes";

const RULE_TEXT_TRANSLATIONS = {
    CHN: [
        [/\bOTHERWISE NON-CHG\b/g, "其他情况不可改签"],
        [/\bREFUND NON-REF AFT DEP\b/g, "起飞后不可退款"],
        [/\bREFUND NON-REF BEF DEP\b/g, "起飞前不可退款"],
        [/\bNON-REF AFT DEP\b/g, "起飞后不可退款"],
        [/\bNON-REF BEF DEP\b/g, "起飞前不可退款"],
        [/\bNON-CHG AFT DEP\b/g, "起飞后不可改签"],
        [/\bNON-CHG BEF DEP\b/g, "起飞前不可改签"],
        [/\bREF AFT DEP\b/g, "起飞后可退款"],
        [/\bREF BEF DEP\b/g, "起飞前可退款"],
        [/\bCHG AFT DEP\b/g, "起飞后可改签"],
        [/\bCHG BEF DEP\b/g, "起飞前可改签"],
        [/\bCHD AFT DEP\b/g, "起飞后可改签"],
        [/\bCHD BEF DEP\b/g, "起飞前可改签"],
        [/\bCHANGES ALLOWED WITH FEE\b/g, "改签需付费"],
        [/\bCHANGE ALLOWED WITH FEE\b/g, "改签需付费"],
        [/\bREFUND ALLOWED WITH FEE\b/g, "退款需付费"],
        [/\bCHANGES NOT ALLOWED\b/g, "不可改签"],
        [/\bCHANGE NOT ALLOWED\b/g, "不可改签"],
        [/\bREFUND NOT ALLOWED\b/g, "不可退款"],
        [/\bCHANGES ALLOWED\b/g, "可改签"],
        [/\bCHANGE ALLOWED\b/g, "可改签"],
        [/\bREFUND ALLOWED\b/g, "可退款"],
        [/\bPENALTY APPLIES\b/g, "有罚金"],
        [/\bNOT PERMITTED\b/g, "不允许"],
        [/\bNOT ALLOWED\b/g, "不允许"],
        [/\bANY TIME\b/g, "任何时间"],
        [/\bNON-REF\b/g, "不可退款"],
        [/\bNO SHOW\b/g, "误机"],
    ],
    ESP: [
        [/\bOTHERWISE NON-CHG\b/g, "DE OTRA FORMA NO CAMBIOS"],
        [/\bREFUND NON-REF AFT DEP\b/g, "NO REEMBOLSABLE DESPUES DE LA SALIDA"],
        [/\bREFUND NON-REF BEF DEP\b/g, "NO REEMBOLSABLE ANTES DE LA SALIDA"],
        [/\bNON-REF AFT DEP\b/g, "NO REEMBOLSABLE DESPUES DE LA SALIDA"],
        [/\bNON-REF BEF DEP\b/g, "NO REEMBOLSABLE ANTES DE LA SALIDA"],
        [/\bNON-CHG AFT DEP\b/g, "NO CAMBIOS DESPUES DE LA SALIDA"],
        [/\bNON-CHG BEF DEP\b/g, "NO CAMBIOS ANTES DE LA SALIDA"],
        [/\bREF AFT DEP\b/g, "REEMBOLSO DESPUES DE LA SALIDA"],
        [/\bREF BEF DEP\b/g, "REEMBOLSO ANTES DE LA SALIDA"],
        [/\bCHG AFT DEP\b/g, "CAMBIOS DESPUES DE LA SALIDA"],
        [/\bCHG BEF DEP\b/g, "CAMBIOS ANTES DE LA SALIDA"],
        [/\bCHD AFT DEP\b/g, "CAMBIOS DESPUES DE LA SALIDA"],
        [/\bCHD BEF DEP\b/g, "CAMBIOS ANTES DE LA SALIDA"],
        [/\bCHANGES ALLOWED WITH FEE\b/g, "CAMBIOS CON CARGO"],
        [/\bCHANGE ALLOWED WITH FEE\b/g, "CAMBIOS CON CARGO"],
        [/\bREFUND ALLOWED WITH FEE\b/g, "REEMBOLSO CON CARGO"],
        [/\bCHANGES NOT ALLOWED\b/g, "CAMBIOS NO PERMITIDOS"],
        [/\bCHANGE NOT ALLOWED\b/g, "CAMBIOS NO PERMITIDOS"],
        [/\bREFUND NOT ALLOWED\b/g, "REEMBOLSO NO PERMITIDO"],
        [/\bCHANGES ALLOWED\b/g, "CAMBIOS PERMITIDOS"],
        [/\bCHANGE ALLOWED\b/g, "CAMBIOS PERMITIDOS"],
        [/\bREFUND ALLOWED\b/g, "REEMBOLSO PERMITIDO"],
        [/\bPENALTY APPLIES\b/g, "APLICA PENALIDAD"],
        [/\bNOT PERMITTED\b/g, "NO PERMITIDO"],
        [/\bNOT ALLOWED\b/g, "NO PERMITIDO"],
        [/\bANY TIME\b/g, "EN CUALQUIER MOMENTO"],
        [/\bNON-REF\b/g, "NO REEMBOLSABLE"],
        [/\bNO SHOW\b/g, "NO PRESENTACION"],
    ],
};

const DEFAULT_JR_OPTIONS = {
    excluded_countries: "FR,GB,NL,US,CA",
    pax: "1ADT",
    carriers: "",
    exact_day: true,
    long_connection: true,
    search_available: true,
    cabin: "Y",
    excluded_carriers: "",
    num_connections: ""
};

function createDefaultJrMask() {
    return {
        FlightSegment: [
            { OriginLocation: "MEX", ConnectionLocation: "", DestinationLocation: "SZX", DepartureDateTime: "" },
            { OriginLocation: "", ConnectionLocation: "", DestinationLocation: "MEX", DepartureDateTime: "" }
        ],
        options: { ...DEFAULT_JR_OPTIONS }
    };
}

function normalizeJrMask(mask = {}) {
    const defaults = createDefaultJrMask();

    return {
        ...defaults,
        ...mask,
        FlightSegment: Array.isArray(mask.FlightSegment) ? mask.FlightSegment : defaults.FlightSegment,
        options: {
            ...DEFAULT_JR_OPTIONS,
            ...(mask.options || {})
        }
    };
}



export default {
    name: "SabreJrEnhanced",
    data() {
        return {
            // jrmask data structure similar to Angular controller
            jrmask: createDefaultJrMask(),
            jr_params_search: "",
            selected_search: null,
            selectedIndex: -1,
            quoteLanguage: "CHN",
            languageOptions: ["CHN", "ESP"],
            serviceChargeOptions: [0, 348, 580, 1000],
            ruleDialog: {
                open: false,
                title: "",
                passengerRules: []
            },
            iatacodes: iatacodesData,
            months: {
                JAN: { CHN: "01月", ESP: "ENE" },
                FEB: { CHN: "02月", ESP: "FEB" },
                MAR: { CHN: "03月", ESP: "MAR" },
                APR: { CHN: "04月", ESP: "ABR" },
                MAY: { CHN: "05月", ESP: "MAY" },
                JUN: { CHN: "06月", ESP: "JUN" },
                JUL: { CHN: "07月", ESP: "JUL" },
                AUG: { CHN: "08月", ESP: "AGO" },
                SEP: { CHN: "09月", ESP: "SEP" },
                OCT: { CHN: "10月", ESP: "OCT" },
                NOV: { CHN: "11月", ESP: "NOV" },
                DEC: { CHN: "12月", ESP: "DIC" }
            },
            day: {
                CHN: "日",
                ESP: ""
            },
            currency: {
                MXN: { CHN: "比索", ESP: "PESOS" }
            },
            passengerType: {
                ADT: { CHN: "成人费用", ESP: "ADULTO" },
                CNN: { CHN: "儿童费用", ESP: "NIÑO" },
                INF: { CHN: "婴儿费用", ESP: "INFANTE" }
            },
            total: {
                CHN: "合计", ESP: "TOTAL"
            },
            jr_params: [],
            selected_itineraries: [],
            result: [],
            // Base API URL (adjust as needed)
            apiUrl: process.env.VUE_APP_API_BASE_URL
        };
    },
    computed: {
        sortedItineraries() {
            // sort selected_itineraries by etc.created_date in descending order if available
            return this.selected_itineraries.slice().sort((a, b) => {
                return new Date(b.etc.created_date) - new Date(a.etc.created_date);
            });
        }
    },
    methods: {
        setFlightSegment(preset) {
            switch (preset) {
                case 'preset0':
                    this.jrmask.FlightSegment = [
                        { OriginLocation: "MEX", DestinationLocation: "PEK", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "MEX", DepartureDateTime: "" }
                    ];
                    break;
                case 'preset1':
                    this.jrmask.FlightSegment = [
                        { OriginLocation: "MEX", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "HKG", DepartureDateTime: "" }
                    ];
                    break;
                case 'preset2':
                    this.jrmask.FlightSegment = [
                        { OriginLocation: "HKG", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "MEX", DepartureDateTime: "" }
                    ];
                    break;
                case 'preset3':
                    this.jrmask.FlightSegment = [
                        { OriginLocation: "HKG", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "MEX", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "NRT", DepartureDateTime: "" }
                    ];
                    break;
                case 'preset4':
                    this.jrmask.FlightSegment = [
                        { OriginLocation: "MEX", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "HKG", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "MEX", DepartureDateTime: "" }
                    ];
                    break;
                case 'preset5':
                    this.jrmask.FlightSegment = [
                        { OriginLocation: "MEX", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "CAN", DepartureDateTime: "" },
                        { OriginLocation: "HKG", DestinationLocation: "NRT", DepartureDateTime: "" },
                        { OriginLocation: "", DestinationLocation: "MEX", DepartureDateTime: "" }
                    ];
                    break;
                default:
                    break;
            }  },
        setJrmask(jp) {
            this.jrmask = normalizeJrMask(JSON.parse(JSON.stringify(jp)));
        },
        hasSegmentInput(segment) {
            return Boolean(
                (segment.OriginLocation || "").trim()
                || (segment.ConnectionLocation || "").trim()
                || (segment.DestinationLocation || "").trim()
                || (segment.DepartureDateTime || "").trim()
                || (segment.Routing || "").trim()
            );
        },
        getSearchableFlightSegments() {
            return this.jrmask.FlightSegment
                .map(segment => ({
                    OriginLocation: (segment.OriginLocation || "").trim(),
                    ConnectionLocation: (segment.ConnectionLocation || "").trim(),
                    DestinationLocation: (segment.DestinationLocation || "").trim(),
                    DepartureDateTime: (segment.DepartureDateTime || "").trim(),
                    Routing: (segment.Routing || "").trim()
                }))
                .filter(segment => this.hasSegmentInput(segment));
        },
        canRunJrSearch(segments) {
            if (!segments.length) {
                return false;
            }

            return segments.every((segment, index) => {
                if (!segment.DestinationLocation) {
                    return false;
                }

                if (!segment.DepartureDateTime || segment.DepartureDateTime.length < 5) {
                    return false;
                }

                if (index === 0 && !segment.OriginLocation) {
                    return false;
                }

                return true;
            });
        },
        getJrParams(text) {
            //return ja_params filtered by text
            return this.jr_params.filter(jp => JSON.stringify(jp).toLowerCase().includes(text.toLowerCase()));
        },
        selectSearch(o, index, command) {
            this.selected_search = o;
            this.selected_search.command = command;
            this.selectedIndex = index;
        },
        formatDisplayTime(value) {
            if (!value) {
                return "";
            }

            const match = String(value).match(/^(\d{2})(\d{2})([A-Z]+)?$/i);

            if (!match) {
                return value;
            }

            return `${match[1]}:${match[2]}${match[3] || ""}`;
        },
        formatFlightIdentifier(airline, flightNumber) {
            const carrier = String(airline || "").trim();
            const rawFlightNumber = flightNumber == null ? "" : String(flightNumber);

            if (!rawFlightNumber) {
                return carrier;
            }

            return `${carrier}${rawFlightNumber}`;
        },
        normalizeJrOption(option) {
            const passengerBreakdown = option.pricingSummary?.passengerBreakdown || [];
            const pax_prices = passengerBreakdown.map(price => ({
                numberOfPax: price.passengerCount,
                passengerType: price.passengerType,
                unitPrice0: price.unitAmount,
                unitPrice348: price.unitAmount + 348,
                unitPrice580: price.unitAmount + 580,
                unitPrice1000: price.unitAmount + 1000
            }));

            const flights = (option.segments || []).map(segment => ({
                seg: segment.segmentNumber,
                airline: segment.carrier,
                number: segment.flightNumber,
                booking_class: segment.bookingClass,
                day: segment.departureDateSabre?.slice(0, 2) || "",
                month: segment.departureDateSabre?.slice(2) || "",
                origin: segment.origin,
                destination: segment.destination,
                departureTime: this.formatDisplayTime(segment.departureTimeLocal),
                arrivalTime: this.formatDisplayTime(segment.arrivalTimeLocal),
                stopText: segment.stops ? `${segment.stops} stop${segment.stops === 1 ? "" : "s"}` : ""
            }));

            const total0 = pax_prices.reduce((sum, price) => sum + (price.unitPrice0 * price.numberOfPax), 0);
            const total348 = pax_prices.reduce((sum, price) => sum + (price.unitPrice348 * price.numberOfPax), 0);
            const total580 = pax_prices.reduce((sum, price) => sum + (price.unitPrice580 * price.numberOfPax), 0);
            const total1000 = pax_prices.reduce((sum, price) => sum + (price.unitPrice1000 * price.numberOfPax), 0);
            const has_brand_pricing = (option.brands || []).some(brand => this.getBrandPricingRows(brand).length > 0);

            return {
                ...option,
                specific_route_matched: Boolean(option.specificRouteMatched),
                flights,
                pax_prices,
                total0,
                total348,
                total580,
                total1000,
                has_brand_pricing,
                validating_carrier: option.validatingCarrier || ""
            };
        },
        normalizeJrSearchResult(result) {
            const parsed_result = (result.options || []).map(option => this.normalizeJrOption(option));
            const totals = parsed_result
                .map(option => this.getLowestOptionTotal(option))
                .filter(total => Number.isFinite(total));
            const displayCommand = result.request?.executedCommand || result.command || "";

            return {
                ...result,
                command: displayCommand,
                inputCommand: result.command || displayCommand,
                parsed_result,
                specific_route_matched: parsed_result.some(option => option.specific_route_matched),
                lowest_total: totals.length ? Math.min(...totals) : null
            };
        },
        getLowestOptionTotal(option) {
            const brandTotals = (option.brands || [])
                .map(brand => this.getBrandTotalFare(brand, 0))
                .filter(total => Number.isFinite(total) && total > 0);

            if (brandTotals.length) {
                return Math.min(...brandTotals);
            }

            return option.pax_prices.length > 0 ? option.total0 : null;
        },
        getBrandPricingRows(brand) {
            if (brand?.pricingBreakdown?.length) {
                return brand.pricingBreakdown;
            }

            if (brand?.pricing && typeof brand.pricing.baseAmount === "number") {
                return [{
                    passengerType: brand.pricing.passengerType || "ADT",
                    passengerCount: Number.isFinite(brand.pricing.passengerCount) ? brand.pricing.passengerCount : 1,
                    baseAmount: brand.pricing.baseAmount,
                    totalAmount: brand.pricing.totalAmount,
                    rawPriceText: brand.pricing.rawPriceText
                }];
            }

            return [];
        },
        getPrimaryBrandRule(brand) {
            return brand?.changeRefund?.passengerRules?.[0] || null;
        },
        getAdditionalBrandRules(brand) {
            return (brand?.changeRefund?.passengerRules || []).slice(1);
        },
        formatRawPassengerRule(rule) {
            if (!rule) {
                return "";
            }

            const text = String(rule.text || "").replace(/\s*\/\s*/g, "\n");

            return rule.passengerType && rule.passengerType !== "ALL"
                ? `${rule.passengerType}: ${text}`
                : text;
        },
        translateRuleText(text, lang = this.quoteLanguage) {
            const normalizedText = String(text || "").replace(/\s+/g, " ").trim();
            const translations = RULE_TEXT_TRANSLATIONS[lang];

            if (!normalizedText || !translations) {
                return normalizedText;
            }

            return normalizedText
                .split(/\s*\/\s*/g)
                .map(segment => this.translateRuleSegment(segment, translations))
                .filter(Boolean)
                .join(" / ");
        },
        translateRuleSegment(segment, translations) {
            let translated = segment
                .toUpperCase()
                .replace(/\bSEE RULES\b/g, "")
                .replace(/\bUP TO MXN\s*(?:\d+(?:[.,]\d+)?|X+)\b/g, "");

            translations.forEach(([pattern, replacement]) => {
                translated = translated.replace(pattern, replacement);
            });

            return translated.replace(/\s+/g, " ").trim();
        },
        formatPassengerRule(rule, lang = this.quoteLanguage) {
            if (!rule) {
                return "";
            }

            return this.translateRuleText(rule.text || "", lang).replace(/\s*\/\s*/g, "\n");
        },
        openBrandRulesDialog(brand) {
            this.ruleDialog = {
                open: true,
                title: `${brand.brandId} ${brand.displayName || brand.descriptor || ""}`.trim(),
                passengerRules: this.getAdditionalBrandRules(brand)
            };
        },
        formatFareAmount(amount) {
            return Number.isFinite(amount)
                ? Math.round(amount).toLocaleString("en-US")
                : "";
        },
        getBrandRowFare(pricingRow, serviceCharge) {
            const baseAmount = typeof pricingRow.baseAmount === "number"
                ? pricingRow.baseAmount
                : (pricingRow.totalAmount || 0);

            return baseAmount + serviceCharge;
        },
        getBrandTotalFare(brand, serviceCharge) {
            const pricingRows = this.getBrandPricingRows(brand);
            if (!pricingRows.length) {
                return 0;
            }

            return pricingRows.reduce((sum, row) => {
                const passengerCount = Number.isFinite(row.passengerCount) ? row.passengerCount : 1;
                return sum + (this.getBrandRowFare(row, serviceCharge) * passengerCount);
            }, 0);
        },
        getDepartureDay(departure) {
            const days = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
            if (departure && departure.length === 5) {
                let today = new Date();
                today.setHours(0, 0, 0, 0);
                let d = new Date(departure + today.getFullYear());
                d.setHours(0, 0, 0, 0);
                return days[d.getDay()];
            }
            return "";
        },
        async getJrCommands() {
            console.log(this.jrmask);
            // save jrmask's value to jr_params
            this.jr_params.unshift(JSON.parse(JSON.stringify(this.jrmask)));
            const searchableFlightSegments = this.getSearchableFlightSegments();

            if (!this.canRunJrSearch(searchableFlightSegments)) {
                console.warn("JR search skipped because the itinerary is still incomplete.");
                return;
            }

            // Save jr_params via API call
            /**
             * 
            try {
                const saveRes = await axios.post(this.apiUrl + "/misc", { type: "JR_PARAMS", etc: this.jrmask });
                this.jr_params.push(saveRes.data);
            } catch (error) {
                console.error("Error saving JR_PARAMS:", error);
            }
             */
            // Post search command to server
            try {
                const response = await axios.post(this.apiUrl + "/gds/sabre/jr-enhanced", {
                    ...this.jrmask,
                    FlightSegment: searchableFlightSegments
                });
                if (response.data?.vmnzs_err) {
                    console.error("VMNZS Error in getting jr result:", response.data.vmnzs_err);
                } else {
                    const data = Array.isArray(response.data) ? response.data : [];
                    this.result = data.map(result => this.normalizeJrSearchResult(result));
                    this.selected_search = null;
                    this.selectedIndex = -1;
                }
            } catch (error) {
                console.error("Error in jr command post:", error);
            }  
        },
        async selectItineraryOption(o, serviceCharge, cabin, selectedBrand = null) {
            const ob = {
                type: "JR_RESULTS",
                etc: {
                    amadeus_command: this.gdsCommand("amadeus", o, cabin),
                    sabre_command: this.gdsCommand("sabre", o, cabin),
                    if_show_flight_number: false,
                    selectedBrand: selectedBrand || null,
                    si: o,
                    serviceCharge: serviceCharge,
                    lang: this.quoteLanguage,
                    jrmask: JSON.parse(JSON.stringify(this.jrmask)),
                    created_date: new Date().toISOString()
                }
            };
            this.selected_itineraries.push(ob);
            /*
            try {
                await axios.post(this.apiUrl + "/misc", ob);
            } catch (error) {
                console.error("Error saving itinerary option:", error);
            }
                */
        } , 
        gdsCommand(gds, o, cabin) {
            let cmd = null;
            if (gds === 'sabre') {
                cmd = 'JR.';
                for(let i = 0; i < o.flights.length; i++){
                    let f = o.flights[i];
                    //should check if it is the first flight, if so, should use both origin and destination
                    //if it is not the first flight, should use only destination
                    //and if origin is different from the previous flight's destination, should use both origin and destination
                    if(i === 0){
                        cmd += f.origin;
                        if(this.selected_search.command.substring(0, 9).includes('¥A')){
                            cmd += '¥A';
                        }
                        cmd += '/S-O' + cabin + f.destination + f.day + f.month + f.departureTime + f.airline + "1";
                    } else if(f.origin !== o.flights[i-1].destination){
                        cmd += '/S-ARUNK' + f.origin + '/S-O' + cabin + f.destination + f.day + f.month + f.departureTime + f.airline + "1";
                    } else{
                        cmd += '/S-O' + cabin + f.destination + f.day + f.month + f.departureTime + f.airline + "1";
                    }
                }
                //JR.MEX/S-OYPEK24APR0245HU1/S-OYSZX25APR1330HU1/S-OYPEK27APR1310HU1/S-OYMEX27APR2010HU1/K-0/P-1ADT
                //JR.MEX/S-OYPEK24APR0245HUPEK/S-OYSZX25APR1330HUSZX/S-OYPEK27APR1310HUPEK/S-OYMEX27APR2010HU/K-0/P-1ADT
                cmd += '/K-0/P-';
                // Loop through pax_prices array
                o.pax_prices.forEach(p => {
                    cmd += p.numberOfPax + p.passengerType;
                });
            } else if (gds === 'amadeus') {
                let numberOfSeats = 0;
                let pax_indicator = '';
                for(let i=0; i<o.pax_prices.length; i++){
                let p = o.pax_prices[i];
                console.log("p:", p);
                if(p.passengerType == 'ADT'){
                    //parseInt(p.numberOfPax) is a number, plus it to numberOfSeats
                    numberOfSeats += parseInt(p.numberOfPax);
                } else if(p.passengerType == 'CNN'){
                    numberOfSeats += parseInt(p.numberOfPax);
                    pax_indicator += '/PAX/' + p.numberOfPax + '/RCH';
                } else if(p.passengerType == 'INF'){
                    pax_indicator += '/INF/' + p.numberOfPax;
                }
            }
            console.log("pax_indicator:", pax_indicator);
            
                cmd = `FXD${numberOfSeats}`;
                o.flights.forEach(f => {
                    // Map cabin as needed; for amadeus: if cabin S then use 'W'
                    let cabinCode = cabin;
                    if(cabin === 'S'){
                        cabinCode = 'W';
                    }
                    console.log("Cabin code:", cabinCode);
                    // todo: check cabinCode
                    cmd += `${f.origin}${f.destination}${f.day}${f.month}${f.departureTime}${f.airline}`;
                });
                cmd += `//FN,D/K${cabin}${pax_indicator}`;
            }
            if(cmd) {
                // Remove all ":" characters
                cmd = cmd.replace(/:/g, '');
                // Copy to clipboard
                navigator.clipboard.writeText(cmd).catch(err => {
                    console.error("Clipboard error:", err);
                });
            }
            return cmd;
        },
        copyDivText(text) {
            navigator.clipboard.writeText(text).catch(err => {
                console.error("Clipboard copy failed:", err);
            });
        },
        itineraryText(itinerary) {
            // Construct text representation of itinerary from itinerary.etc
            // This function should be adjusted based on the itinerary structure.
            let output = '';
            if (itinerary.etc && itinerary.etc.si) {
                let watermark = ">";
                if(itinerary.etc.sabre_command.substring(0, 9).includes('¥A')){
                    output += "非实时报价[PRECIOS NO REALES]\n";
                    watermark = "-";
                }
                const flightsText = itinerary.etc.si.flights.map(f => {
                    const month = this.months[f.month][itinerary.etc.lang];
                    const day = this.day[itinerary.etc.lang];
                    const origin = this.iatacodes[f.origin]?.[itinerary.etc.lang] || f.origin;
                    const destination = this.iatacodes[f.destination]?.[itinerary.etc.lang] || f.destination;
                    const flightNumber = itinerary.etc.if_show_flight_number ? `${f.booking_class} ${this.formatFlightIdentifier(f.airline, f.number)}` : '';
                    return `${month}${f.day}${day} ${flightNumber} ${origin} ${watermark} ${destination} ${f.departureTime} - ${f.arrivalTime}`;
                }).join('\n');

                const currency = this.currency.MXN[itinerary.etc.lang];
                const selectedBrand = itinerary.etc.selectedBrand;
                const paxPricesSource = selectedBrand
                    ? this.getBrandPricingRows(selectedBrand).map(row => ({
                        numberOfPax: row.passengerCount,
                        passengerType: row.passengerType,
                        unitPrice: this.getBrandRowFare(row, itinerary.etc.serviceCharge)
                    }))
                    : itinerary.etc.si.pax_prices.map(pp => ({
                        numberOfPax: pp.numberOfPax,
                        passengerType: pp.passengerType,
                        unitPrice: pp["unitPrice" + itinerary.etc.serviceCharge]
                    }));
                const paxPricesText = paxPricesSource.map(pp => {
                    const passengerType = this.passengerType[pp.passengerType][itinerary.etc.lang];
                    return `${passengerType}: ${pp.unitPrice.toFixed(0)} ${currency} X ${pp.numberOfPax}`;
                }).join('\n');

                const total = this.total[itinerary.etc.lang];
                const totalPrice = selectedBrand
                    ? this.getBrandTotalFare(selectedBrand, itinerary.etc.serviceCharge).toFixed(0)
                    : itinerary.etc.si["total" + itinerary.etc.serviceCharge].toFixed(0);
                const primaryRule = selectedBrand ? this.getPrimaryBrandRule(selectedBrand) : null;
                const formattedPrimaryRule = primaryRule
                    ? this.formatPassengerRule(primaryRule, itinerary.etc.lang)
                    : "";

                output += `${flightsText}\n`;
                output += `${paxPricesText}\n${total}: ${totalPrice} ${currency}`;
                if (formattedPrimaryRule) {
                    output += `\n${formattedPrimaryRule}`;
                }
            }
            navigator.clipboard.writeText(output).catch(err => {
                console.error("Clipboard copy failed:", err);
            });
            return output;
        },
        async loadJrParams() {
            try {
                const res = await axios.get(this.apiUrl + "/jr_params");
                this.jr_params = (res.data || []).map(param => normalizeJrMask(param));
            } catch (error) {
                console.error("Error loading JR params:", error);
            }
        },
        async loadItineraries() {
            try {
                const res = await axios.get(this.apiUrl + "/jr_results");
                this.selected_itineraries = res.data;
            } catch (error) {
                console.error("Error loading itineraries:", error);
            }
        },
    },
    created() {
    //    this.loadJrParams();
    //    this.loadItineraries();
    }
};
</script>

<style scoped>
.monospace {
    font-family: monospace;
}
.color-red {
    color: red;
}
.color-green {
    color: green;
}
.stickydiv {
    position: sticky;
    top: 60px;
    z-index: 10; /* Adjust the z-index value as needed */
}
.input-group-addon {
    white-space: pre-wrap;
}
.flight-identifier {
    white-space: pre-wrap;
}
.brand-block {
    margin-top: 14px;
    font-size: 12px;
    line-height: 1.4;
}
.brand-line + .brand-line {
    margin-top: 10px;
}
.brand-line {
    padding: 12px 14px;
    border: 1px solid #d6dce8;
    border-radius: 14px;
    background: linear-gradient(180deg, #fbfcfe 0%, #f3f6fb 100%);
    box-shadow: 0 8px 18px rgba(23, 41, 73, 0.06);
}
.brand-title {
    font-weight: 600;
    font-size: 13px;
    color: #16233a;
}
.brand-tags {
    color: #4f6385;
    font-weight: 500;
}
.brand-details {
    display: grid;
    grid-template-columns: minmax(0, 1.8fr) minmax(240px, 1fr);
    gap: 16px;
    align-items: flex-start;
    margin-top: 10px;
}
.brand-rules-panel {
    min-height: 100%;
    padding: 12px;
    border: 1px solid #d8dee9;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}
.brand-panel-title {
    margin-bottom: 8px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #60718f;
}
.brand-rules {
    white-space: pre-line;
    line-height: 1.55;
    color: #22324f;
}
.brand-rules-more {
    margin-top: 10px;
    padding: 0 10px;
    border: 1px solid #f0bf53;
    border-radius: 999px;
    background: #fff3d4;
    color: #8b5a00;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: none;
}
.brand-table {
    min-width: 0;
}
.jr-fare-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: #ffffff;
    border: 1px solid #d8dee9;
    border-radius: 12px;
    overflow: hidden;
}
.jr-fare-table thead th {
    padding: 9px 10px;
    background: #eaf0f8;
    color: #4f6385;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}
.jr-fare-table tbody td {
    padding: 10px;
    border-top: 1px solid #edf1f7;
    color: #1a2740;
}
.jr-fare-table tbody tr:first-child td {
    border-top: none;
}
.fare-label-cell {
    min-width: 86px;
    text-align: left;
    font-weight: 600;
    color: #253653;
}
.fare-charge-cell {
    text-align: right;
}
.fare-total-row td {
    background: #f8fafc;
    font-weight: 700;
}
.fare-link {
    color: #1752b5;
    font-weight: 600;
    text-decoration: none;
}
.fare-link:hover {
    text-decoration: underline;
}
.fare-link--total {
    color: #0f3e90;
}
.jr-fare-table--plain {
    margin-top: 8px;
    max-width: 520px;
}
.option-links {
    margin-top: 10px;
    text-align: right;
}
.brand-rule-dialog-line {
    padding: 10px 12px;
    border: 1px solid #e5e9f2;
    border-radius: 10px;
    background: #f7f9fc;
    white-space: pre-line;
    line-height: 1.5;
}
.brand-rule-dialog-line + .brand-rule-dialog-line {
    margin-top: 8px;
}
@media (max-width: 900px) {
    .brand-details {
        grid-template-columns: 1fr;
    }
    .brand-rules-panel {
        min-height: auto;
    }
}
</style>
